import { Brand } from '@/api/type';
import closeBrand from '@/assets/images/brand-modal-close.png';
import xwxBrand from '@/assets/images/xwx-brand.png';
import xwxsyBrand from '@/assets/images/xwxsy-brand.png';
import { Modal, message } from 'ant-design-vue';
import { ref } from 'vue';
import './index.less';

const brandData = [
  {
    name: '希望学',
    value: Brand.xwx,
    img: xwxBrand,
    with: 50
  },
  {
    name: '希望学素养',
    value: Brand.xwxsy,
    img: xwxsyBrand,
    with: 80
  }
];
/**
 * 选择的品牌 默认是希望学
 */
const chooseBrandType = ref<Brand>(Brand.xwx);
/**
 * 点击关闭模版
 */
const closeModal = () => {
  message.open({
    type: 'info',
    content: '您必须选择所需的品牌后，才可使用教师工作台系统',
    class: 'brand-message',
    icon: <span></span>
  });
};
/**
 * 点击选择不同的模版
 * @param value 选择的类型
 */
const chooseBrand = (value: Brand) => {
  chooseBrandType.value = value;
};
const showBrandModal = () => {
  Modal.info({
    title: (
      <div class={'brand-title'}>
        <span>品牌选择</span>
        <img src={closeBrand} alt="" class={'brand-title-close'} onClick={closeModal} />
      </div>
    ),
    icon: () => <span></span>,
    width: '700px',
    wrapClassName: 'warp-class-brand-modal',
    okText: '确认',
    class: 'brand-modal',
    content: () => {
      return (
        <div class={'flex justify-center w-full h-full border-b border-t border-gray-EEEEEF border-solid text-center brand-div'}>
          {brandData.map((item) => {
            return (
              <div class={`brand-div-img ${item.value === chooseBrandType.value ? 'brand-div-img-active' : ''}`} onClick={() => chooseBrand(item.value)}>
                <img src={item.img} style={{ width: `${item.with}px` }} alt="" />
              </div>
            );
          })}
        </div>
      );
    },
    onOk: () => {
      // 如果已经有选择的品牌则不再选择
      const brand = localStorage.getItem('Teacher-Desk-X-BRAND');
      if (brand && brand !== chooseBrandType.value) {
        message.open({
          type: 'info',
          content: '需要退出已经登录的品牌后，再选择其他品牌使用',
          class: 'brand-message',
          icon: <span></span>
        });
        showBrandModal();
        return false;
      }
      localStorage.setItem('Teacher-Desk-X-BRAND', chooseBrandType.value);
      location.reload();
    }
  });
};

export default showBrandModal;
